module.exports = __webpack_public_path__ + "img/btn-kakao.a211ab37.png";